var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_392_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 40V0H40V40H0Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1525 29.9407C26.9214 31.1896 27.7569 32.3862 29.5269 32.3862C31.0136 32.3862 31.7936 31.6473 31.7936 30.6251C31.7936 29.4018 30.9869 28.9673 29.3514 28.2551L28.4547 27.8729C25.8669 26.7751 24.1458 25.3996 24.1458 22.494C24.1458 19.8162 26.1958 17.7785 29.3991 17.7785C31.6803 17.7785 33.3191 18.5685 34.5014 20.6373L31.708 22.4229C31.0936 21.3251 30.4291 20.8929 29.3991 20.8929C28.348 20.8929 27.6825 21.5562 27.6825 22.4229C27.6825 23.494 28.3491 23.9273 29.888 24.5907L30.7847 24.9729C33.8347 26.2718 35.5547 27.5985 35.5547 30.5807C35.5547 33.794 33.0169 35.5551 29.6103 35.5551C26.278 35.5551 24.3858 33.8829 23.3325 31.8129L26.1525 29.9407ZM13.2791 30.0318C13.8414 31.0385 14.6958 31.8129 15.9247 31.8129C17.1003 31.8129 17.7769 31.3485 17.7769 29.5429V17.7773H21.4803V30.1118C21.4803 33.8529 19.3103 35.5551 16.1414 35.5551C13.278 35.5551 11.2114 33.6151 10.3691 31.8129L13.2791 30.0318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_392_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0292969 40V0H40.0293V40H0.0292969Z",
    fill: "#FFD600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1818 29.9407C26.9507 31.1896 27.7862 32.3862 29.5562 32.3862C31.0429 32.3862 31.8229 31.6473 31.8229 30.6251C31.8229 29.4018 31.0162 28.9673 29.3807 28.2551L28.484 27.8729C25.8962 26.7751 24.1751 25.3996 24.1751 22.494C24.1751 19.8162 26.2251 17.7785 29.4284 17.7785C31.7095 17.7785 33.3484 18.5685 34.5307 20.6373L31.7373 22.4229C31.1229 21.3251 30.4584 20.8929 29.4284 20.8929C28.3773 20.8929 27.7118 21.5562 27.7118 22.4229C27.7118 23.494 28.3784 23.9273 29.9173 24.5907L30.814 24.9729C33.864 26.2718 35.584 27.5985 35.584 30.5807C35.584 33.794 33.0462 35.5551 29.6395 35.5551C26.3073 35.5551 24.4151 33.8829 23.3618 31.8129L26.1818 29.9407ZM13.3084 30.0318C13.8707 31.0385 14.7251 31.8129 15.954 31.8129C17.1295 31.8129 17.8062 31.3485 17.8062 29.5429V17.7773H21.5095V30.1118C21.5095 33.8529 19.3395 35.5551 16.1707 35.5551C13.3073 35.5551 11.2407 33.6151 10.3984 31.8129L13.3084 30.0318Z",
    fill: "#000001"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_392_230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_392_230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.0292969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsLogo);
export default __webpack_public_path__ + "static/media/js-logo.63196b15617a7f4b1c835884bcf25ab6.svg";
export { ForwardRef as ReactComponent };